import React, { type FC, type ReactNode, useCallback, useEffect, useRef } from 'react';

import { bind, type UnbindFn } from 'bind-event-listener';

import { type FocusableElement } from '../../types';
import handleFocus from '../utiles/handle-focus';
import { FocusManagerContext } from './focus-manager-context';

const FocusManager: FC<{ children: ReactNode }> = ({ children }) => {
	const menuItemRefs = useRef<FocusableElement[]>([]);
	const registerRef = useCallback((ref: FocusableElement) => {
		if (ref && !menuItemRefs.current.includes(ref)) {
			menuItemRefs.current.push(ref);
		}
	}, []);

	// set focus and intentionally rebinding listener and clean up listener on each render
	useEffect(() => {
		bind(window, {
			type: 'keydown',
			listener: handleFocus(menuItemRefs.current),
		});

		const unbind: UnbindFn = () => {
			bind(window, {
				type: 'keydown',
				listener: handleFocus(menuItemRefs.current),
			});
		};

		return unbind;
	}, []);

	const contextValue = {
		menuItemRefs: menuItemRefs.current,
		registerRef,
	};

	return (
		<FocusManagerContext.Provider value={contextValue}>{children}</FocusManagerContext.Provider>
	);
};

export default FocusManager;
